<div *ngIf="opened" class="header-search-panel amadeus-direct-style" @showSearchPanel>
  <div id="siteSearch" class="header-search">
    <div class="container">
      <div class="header-search-container">
        <form id="headerSearchForm" [formGroup]="searchForm" class="px-lg-8 px-md-8">
          <div class="d-flex flex-row">
            <div
              class="search-word col-0 pe-3 align-items-center d-flex"
              id="globalSearchText"
              i18n="@@header-search.commonGlobalSearchSearch"
            >
              Search
            </div>
            <div class="w-25 mx-2">
              <ng-select
                [searchable]="false"
                [clearable]="false"
                [items]="category"
                bindLabel="title"
                formControlName="type"
              >
              </ng-select>
            </div>
            <div class="w-75 input-group df-input-prepend rtl-prepend-header-search">              
              <div class="input-group-prepend">
                <button class="input-group-text fa-magnifying-glass float-end" (click)="search()">
                  <span class="visually-hidden" i18n="@@header-search.commonGlobalSearchSearch">Search</span>
                </button>
              </div>
              <input
                class="header-search-input search-input-header"
                id="headerSearchInput"
                type="text"
                formControlName="search"
                (keyup)="onKeyup($event)"
              />
            </div>
            <div class="header-seacrh-cancel">
              <a
                class="header-search-close df-link-icononly fa-xmark p-0 align-items-center d-flex"
                (click)="close()"
              >
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
